<!--第三方登录路由-->
<template>
	<div><overdue-prompt ref="overduePrompt" @loginOut="loginOut"></overdue-prompt></div>
</template>

<script>
import OverduePrompt from '@/views/components/main/OverduePrompt.vue';

import loginApi from '@/api/login';

export default {
	name: 'Outside',
	components: {
		OverduePrompt
	},
	data() {
		return {};
	},
	created() {
		this.openAuth();
		//        let that = this
		//        loginApi.getUserInfo().then(userInfo =>{
		//            that.$cookies.set("userInfo",userInfo.returnData, 30*60*60);
		//            that.$cookies.set("isLogin",true, 30*60*60);
		//            let dueDate = userInfo.returnData.custInfo.dueDate;
		//            let currentdate = new Date();

		//            if (new Date(dueDate).getTime() < currentdate.getTime()) {
		//                that.$refs.overduePrompt.show();
		//            }else {

		// //判断是否有参数 可以链到  专题分析报告界面
		// if(this.$route.query.content){
		// 	// console.log(this.$route.query.content)
		// 	//先缓存 路由 否则跳不过去
		// 	window.sessionStorage.setItem('activePath', `/monitoring/monitoring`);
		// 	//在监测专题页跳转分析报告的依据
		// 	window.sessionStorage.setItem('content', this.$route.query.content);
		// 	this.$router.push(`/monitoring/monitoring`)

		// }else{
		// 	this.$router.push('/home/home')
		// }
		//            }
		//        })
	},
	methods: {
		loginOut: function() {
			loginApi.logout().then(res => {
				this.$cookies.remove('userInfo');
				this.$cookies.remove('isLogin');
				this.$router.push('/');
			});
		},
		openAuth: async function() {
			if (this.$route.query.openId) {
				console.log(this.$route.query.openId)
				// console.log(this.$encrypt('1545646'))
				let openId = this.$decrypt(this.$route.query.openId);
				var json = {
					openId: openId,
					authDate: this.$moment(new Date()).format('yyyy-MM-DD HH:mm:ss')
				};
				let res = await loginApi.openAuth(json);
				console.log(res)
				if (res.returnData.result == 'success') {
					this.getUserInfo();
				} else {
					that.$router.push({ name: 'Login' });
				}
			} else {
				this.getUserInfo();
			}
		},
		getUserInfo: async function() {
			let that = this;
			loginApi.getUserInfo().then(userInfo => {
				that.$cookies.set('userInfo', userInfo.returnData, 30 * 60 * 60);
				that.$cookies.set('isLogin', true, 30 * 60 * 60);
				let dueDate = userInfo.returnData.custInfo.dueDate;
				let currentdate = new Date();

				if (new Date(dueDate).getTime() < currentdate.getTime()) {
					that.$refs.overduePrompt.show();
				} else {
					//判断是否有参数 可以链到  专题分析报告界面
					if (this.$route.query.content) {
						// console.log(this.$route.query.content)
						//先缓存 路由 否则跳不过去
						window.sessionStorage.setItem('activePath', `/monitoring/monitoring`);
						//在监测专题页跳转分析报告的依据
						window.sessionStorage.setItem('content', this.$route.query.content);
						this.$router.push(`/monitoring/monitoring`);
					} else {
						this.$router.push('/home/home');
					}
				}
			});
		}
	}
};
</script>

<style scoped></style>
